var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 253.3 40.7",
    style: {
      enableBackground: "new 0 0 253.3 40.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_976_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1026_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1027_",
    className: "st0",
    d: "M198.1,40.7h-18.3c-11.1,0-20.1-9.1-20.1-20.2c0-11.2,9-20.2,20.1-20.2h18.3 c1.8,0,3.2,1.4,3.2,3.2s-1.4,3.2-3.2,3.2h-18.3c-7.6,0-13.7,6.2-13.7,13.8c0,7.6,6.1,13.8,13.7,13.8h18.3c1.8,0,3.2,1.4,3.2,3.2 C201.3,39.3,199.9,40.7,198.1,40.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1024_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1025_",
    className: "st0",
    d: "M33.6,40.7c-0.8,0-1.6-0.3-2.3-0.9L14.2,22.7c-0.9-0.9-1.2-2.3-0.7-3.5c0.5-1.2,1.7-2,2.9-2 h9.2c2.8,0,5.1-2.3,5.1-5.1s-2.3-5.1-5.1-5.1H6.4v30.1c0,1.8-1.4,3.2-3.2,3.2S0,38.8,0,37.1V3.7C0,2,1.4,0.5,3.2,0.5h22.5 c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5h-1.5l11.7,11.7c1.2,1.2,1.2,3.3,0,4.5C35.2,40.4,34.4,40.7,33.6,40.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1022_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1023_",
    className: "st0",
    d: "M102.8,40.7c-0.5,0-1-0.1-1.5-0.4c-1.6-0.8-2.2-2.7-1.4-4.3l15.9-30.7 c1.6-3.3,4.5-5.3,7.8-5.3c0,0,0,0,0,0c3.3,0,6.3,2,7.9,5.4L147.4,36c0.8,1.6,0.2,3.5-1.4,4.3c-1.6,0.8-3.5,0.2-4.3-1.4L125.9,8.3 c-0.6-1.2-1.4-1.9-2.2-1.9c0,0,0,0,0,0c-0.8,0-1.6,0.7-2.1,1.8L105.7,39C105.1,40.1,104,40.7,102.8,40.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1017_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1020_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1021_",
    className: "st0",
    d: "M233,40.7c-1.8,0-3.2-1.4-3.2-3.2V8c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2v29.5 C236.2,39.3,234.8,40.7,233,40.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1018_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1019_",
    className: "st0",
    d: "M250.1,26.9c-1,0-1.9-0.5-2.6-1.3L234.2,7.4c-0.6-0.9-1.7-0.9-2.3,0l-13.4,18.2 c-1,1.4-3,1.7-4.5,0.7c-1.4-1-1.7-3-0.7-4.5l13.4-18.2c1.5-2.1,3.8-3.3,6.3-3.3h0c2.5,0,4.8,1.2,6.3,3.3l13.4,18.2 c1,1.4,0.7,3.4-0.7,4.5C251.5,26.7,250.8,26.9,250.1,26.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1002_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1015_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1016_",
    className: "st0",
    d: "M84.1,6.9H58.2c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2h25.9c1.8,0,3.2,1.4,3.2,3.2 S85.9,6.9,84.1,6.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1012_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1014_",
    className: "st0",
    d: "M70.9,23.8H58.2c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2h12.7c1.8,0,3.2,1.4,3.2,3.2 S72.6,23.8,70.9,23.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1010_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1011_",
    className: "st0",
    d: "M84.1,40.7H58.2c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2h25.9c1.8,0,3.2,1.4,3.2,3.2 C87.3,39.3,85.9,40.7,84.1,40.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.48b4cdecfc85e9eb74e15d33b3af4ac0.svg";
export { ForwardRef as ReactComponent };